var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBannerIllustrationChrome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 110,
    viewBox: "0 0 90 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2516_1632)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 110,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 17.5,
    y: 26.5,
    width: 55,
    height: 55,
    rx: 15.5,
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 13.5,
    y: 22.5,
    width: 63,
    height: 63,
    rx: 19.5,
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 9.5,
    y: 18.5,
    width: 71,
    height: 71,
    rx: 23.5,
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 5.5,
    y: 14.5,
    width: 79,
    height: 79,
    rx: 27.5,
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 110,
    fill: "url(#paint0_linear_2516_1632)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 30,
    width: 48,
    height: 48,
    rx: 12,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0004 63.4995C50.2474 63.4995 54.5008 59.2459 54.5008 53.9989C54.5008 48.7519 50.2474 44.4983 45.0004 44.4983C39.7534 44.4983 35.5 48.7519 35.5 53.9989C35.5 59.2459 39.7534 63.4995 45.0004 63.4995Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7727 58.7514L28.5463 44.5029C26.8783 47.3911 26 50.6675 26 54.0029C26 57.3384 26.8779 60.6147 28.5457 63.5029C30.2135 66.3911 32.6124 68.7896 35.501 70.4566C38.3896 72.1236 41.6664 73.0009 45.0016 72.9999L53.228 58.7514V58.7492C52.3947 60.1942 51.1957 61.3943 49.7515 62.2287C48.3073 63.0631 46.6689 63.5025 45.001 63.5027C43.3331 63.5029 41.6945 63.064 40.2501 62.2301C38.8057 61.3961 37.6063 60.1964 36.7727 58.7518V58.7514Z",
    fill: "#229342"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2271 58.7509L45.0009 72.9994C48.3362 73 51.6128 72.1221 54.5012 70.4547C57.3896 68.7873 59.788 66.3886 61.4555 63.5C63.1228 60.6114 64.0003 57.3348 63.9998 53.9996C63.9992 50.6644 63.1205 47.388 61.4521 44.5H44.9996L44.9976 44.5014C46.6654 44.5006 48.3041 44.939 49.7489 45.7725C51.1937 46.6061 52.3933 47.8051 53.2275 49.2495C54.0617 50.6939 54.5008 52.3324 54.5008 54.0003C54.5007 55.6683 54.0615 57.3068 53.2273 58.7511L53.2271 58.7509Z",
    fill: "#FBC116"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0007 61.5224C49.1546 61.5224 52.5219 58.155 52.5219 54.0009C52.5219 49.8469 49.1546 46.4797 45.0007 46.4797C40.8468 46.4797 37.4795 49.8471 37.4795 54.0009C37.4795 58.1548 40.8468 61.5224 45.0007 61.5224Z",
    fill: "#1A73E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0008 44.5006H61.4533C59.7861 41.612 57.3878 39.2131 54.4994 37.5453C51.6111 35.8776 48.3346 34.9997 44.9994 35C41.6642 35.0002 38.3878 35.8785 35.4998 37.5467C32.6117 39.2148 30.2137 41.6139 28.5469 44.5028L36.7732 58.7513L36.7754 58.7525C35.9408 57.3084 35.5011 55.67 35.5006 54.0021C35.5 52.3342 35.9387 50.6955 36.7724 49.2509C37.606 47.8063 38.8057 46.6067 40.2501 45.7728C41.6945 44.939 43.3332 44.5 45.0012 44.5004L45.0008 44.5006Z",
    fill: "#E33B2E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2516_1632",
    x1: 0,
    y1: 55,
    x2: 90,
    y2: 55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.489583,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.966552
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2516_1632"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 110,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerIllustrationChrome);
export default __webpack_public_path__ + "static/media/banner-illustration-chrome.1deb80a3844cb21ddf5a37825484dab9.svg";
export { ForwardRef as ReactComponent };